/*
 * @Author: dongqingming
 * @Date: 2021-08-10 21:13:35
 * @LastEditTime: 2024-10-18 17:00:33
 * @LastEditors: jiangfeng
 * @Description: Do not edit
 * @FilePath: /governance-driver-projects/packages/acceptor-center/src/service/url.js
 * no bug no code
 */
/* eslint-disable one-var */
import { env } from '@/utils/env';

// eslint-disable-next-line no-unused-vars
const domainDev = 'https://mock.xiaojukeji.com/mock/3143';
// eslint-disable-next-line one-var
const domainStage = 'http://10.167.66.127:8018';
// eslint-disable-next-line one-var
const domainPre = 'http://100.69.239.221:8000';
// eslint-disable-next-line one-var
const domainOnline = '//acceptor.xiaojukeji.com';
// eslint-disable-next-line no-unused-vars
const domainOsim = '//acceptor-dev.xiaojukeji.com';
// eslint-disable-next-line one-var, no-unused-vars
const { isPre, isStage, isDev, isStable } = env;
// eslint-disable-next-line no-unused-vars
const GPUX_PAGE_CONFIG = process.env.GPUX_PAGE_CONFIG;

const { biz } = GPUX_PAGE_CONFIG.extra;

// 证据中心图片上传接口
// eslint-disable-next-line one-var
const ecologyUrl = 'https://ihap-ecology.xiaojukeji.com';

let baseUrl = domainOnline;

let configUrl = '//10.96.79.45:8888';
let switchUrl = '//10.96.85.212:9091';
let apiUrl = '//api.udache.com';
let juanzongBUrl = 'https://hhbcpre.intra.xiaojukeji.com';

console.log('isStable', isStable);

if (isDev) {
  baseUrl = domainDev;
  configUrl = domainDev;
  switchUrl = domainDev;
} else if (isStage) {
  baseUrl = domainStage;
  configUrl = '//10.96.79.45:8888/uoka/v1/accept';
  switchUrl = '//10.96.85.212:9091';
} else if (isStable) {
  baseUrl = domainOsim;
  configUrl = '//zhixing.intra.xiaojukeji.com/uoka/v1/accept';
  switchUrl = '//ihap-boya-dev.xiaojukeji.com';
} else if (isPre) {
  baseUrl = domainPre;
  configUrl = '//10.181.200.143:8088/uoka/v1/accept';
  switchUrl = '//10.166.14.190:9091';
} else {
  baseUrl = domainOnline;
  configUrl = '//zhixing.intra.xiaojukeji.com/uoka/v1/accept';
  switchUrl = '//ihap-boya.xiaojukeji.com';
}
console.log(baseUrl, configUrl);

const url = {
  defineScene: `${baseUrl}/acceptor/v1/complaint/define_scene`,
  preCheck: `${baseUrl}/acceptor/v1/self-service/forecast`,
  submit: `${baseUrl}/acceptor/v1/self-service/commit`,
  getProgress: `${baseUrl}/acceptor/v1/compliant/progress_detail`,
  getProgressFromJZ: `${juanzongBUrl}/acceptor/v1/tool/progress_detail`,
  getDriverPhone: `${baseUrl}/acceptor/v1/action/call_driver`,
  getRule: `${baseUrl}/acceptor/v1/rule/info`,
  ecologyUpload: `${ecologyUrl}/ihap/evidence/outer/file/v1/upload`,
  specialGetProgress: `${baseUrl}/acceptor/v1/complaint/accept_progress_detail`,
  switch: `${switchUrl}/boya/outer/v1/accept/forecast/switch`,
  userPop: `${apiUrl}/gulfstream/iapetos/service/getUserPop`,
};

// 配置化的mock接口
export const mockUrl = {
  preCheck: `${configUrl}/boya/acceptor/config/v1/self-service/mock/forecast`,
  defineScene: `${configUrl}/boya/acceptor/config/v1/self-service/mock/define_scene`,
  submit: `${configUrl}/boya/acceptor/config/v1/self-service/mock/commit`,
  getProgress: `${configUrl}/boya/acceptor/config/v1/self-service/mock/progress_detail`
};

// const proxyUrl = new Proxy(url, {
//   get: function(target, prop) {
//     if (biz === 'web' && mockUrl[prop] !== undefined) {
//       return mockUrl[prop];
//     } else {
//       return target[prop];
//     }
//   }
// });
let proxyUrl = {};
const keys = Object.keys(url);
for (let i = 0; i < keys.length; i++) {
  let key = keys[i];
  Object.defineProperty(proxyUrl, keys[i], {
    get: () => {
      if (biz === 'web' && mockUrl[key] !== undefined) {
        return mockUrl[key]
      }
      return url[key]
    }
  })
}

export default proxyUrl;
